import { ReplaceableComponentsService } from '@abp/ng.core';
import { eThemeLeptonXComponents } from '@abp/ng.theme.lepton-x';
import { APP_INITIALIZER } from '@angular/core';
import { AppMobileNavbarComponent } from './mobile-navbar.component';

/**
 * ABP's SideMenuApplicationLayoutComponent already declares
 * `<ng-template lpx-mobile-navbar-panel>` behind `*abpIfReplaceableTemplateExists`, so registering
 * this key hands us the whole mobile navbar without touching the layout or node_modules.
 */
export const MOBILE_NAVBAR_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    useFactory: (replaceableComponents: ReplaceableComponentsService) => () => {
      replaceableComponents.add({
        key: eThemeLeptonXComponents.MobileNavbar,
        component: AppMobileNavbarComponent,
      });
    },
    deps: [ReplaceableComponentsService],
    multi: true,
  },
];
